import React from 'react';
import { Container, Typography, Box, Paper, Alert } from '@mui/material';
import { Send as SendIcon, Info as InfoIcon } from '@mui/icons-material';
import BulkMessageForm from '../components/BulkMessageForm';

const BulkMessages: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SendIcon />
          Mensagens em Massa
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Envie mensagens em massa usando a integração com UTalk
        </Typography>
      </Box>

      {/* Informações sobre a funcionalidade */}
      <Paper sx={{ p: 3, mb: 4, bgcolor: 'info.light', color: 'info.contrastText' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          <InfoIcon sx={{ mt: 0.5 }} />
          <Box>
            <Typography variant="h6" gutterBottom>
              Como usar o Envio de Mensagens em Massa
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Esta funcionalidade permite enviar mensagens em massa através da API da UTalk:
            </Typography>
            <Box component="ul" sx={{ pl: 2, m: 0 }}>
              <li><strong>Channel ID:</strong> ID do canal WhatsApp configurado na UTalk</li>
              <li><strong>Template Message ID:</strong> ID do template de mensagem aprovado</li>
              <li><strong>Contatos:</strong> Lista de contatos com nome, telefone e variáveis opcionais</li>
              <li><strong>Agendamento:</strong> Opcional - agende o envio para uma data/hora específica</li>
              <li><strong>Tags:</strong> Categorize as mensagens para organização</li>
            </Box>
          </Box>
        </Box>
      </Paper>

      {/* Formulário */}
      <BulkMessageForm />
    </Container>
  );
};

export default BulkMessages;
